function flatten(data, c): any {
    const result = {};
    for (const i in data) {
        if (typeof data[i] === 'object') {
            Object.assign(result, flatten(data[i], c + '.' + i));
        } else {
            if (i.indexOf('@') !== 0) {
                result[(c + '.' + i).replace(/^\./, '')] = data[i];
            }
        }
    }
    return result;
}

export function valueHash(object: any): string {
    return Object.values(flatten(object, '')).map((v) => v === '0' ? '' : v).join('');
}
